import React from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";
import SideBar from "../components/account/SideBar";
import { useSelector } from "react-redux";

const AccountLayout = ({ title, lastUpdated, children }) => {
  const navigate = useNavigate();
  const user = useSelector((state) => state.user.user);
  return (
    <>
      <Header />
      <main data-router-wrapper>
        <section
          className="js-page page account "
          data-router-view="accountDetails"
        >
          <section className="fat-header">
            <div className="inner">
              <h1>Hello, {user && user.name}</h1>
            </div>
          </section>

          <section className="page-content">
            <SideBar/>
            <main className="page challenges">
              {children}
            </main>
          </section>

          <span className="js-user-witness"></span>
        </section>
      </main>
    </>
  );
};

export default AccountLayout;
